import * as React from 'react';
import { get } from 'lodash';
import FilterList from 'material-ui/svg-icons/content/filter-list';
import AttachMoney from 'material-ui/svg-icons/editor/attach-money';

import { EnhancedExportButton } from '@components/exportButton/ExportButton';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { getConfigurationContext } from '@components/provider/configuration/ConfigurationProvider';
import { ModalButton } from '@components/modalButton/ModalButton';
import { FiltersMemoryForm } from '@components/filtersMemory/FiltersMemoryForm';
import { DelictsFineValuesForm } from '@modules/delicts/DelictsFineValuesForm';

const parseBool = (value: string | boolean) => {
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true';
  }
  return !!value;
};

const ActionBar: React.FC<Record<string, any>> = ({ state, filters, setFilters, columns, items, checkedItems }) => {
  const { config } = getConfigurationContext();

  const filtersmemory = parseBool(get(config, 'extensions.filtersmemory', false));

  return (
    <React.Fragment>
      {filtersmemory && (
        <ModalButton
          label="Paměť filtrů"
          icon={<FilterList />}
          ModalComponent={FiltersMemoryForm}
          module="delicts"
          filters={filters}
          setFilters={setFilters}
          columns={columns}
          style={{ marginLeft: 5 }}
        />
      )}
      <ColumnManager agenda={Agenda.DELICTS} />
      <EnhancedExportButton location={'delictOverview'} params={state} />
      <ModalButton
        label="Součet pokut"
        icon={<AttachMoney />}
        ModalComponent={DelictsFineValuesForm}
        module="delicts"
        style={{ marginLeft: 5 }}
        {...{ items, checkedItems }}
      />
    </React.Fragment>
  );
};

export default ActionBar;



// WEBPACK FOOTER //
// ./src/modules/delicts/DelictsGridButtons.tsx